export default function(event, payload = {}) {
  this.observers.forEach(observer => {
    // console.log(observer.item);
    if (!payload.chartId || (payload.chartId && observer.id === payload.chartId)) observer.item.update(event, payload);
  });
}
